<template>
  <main class="wrapper-content w-100">
    <!-- Loading -->
    <LmComponentLoading v-if="isLoading" fixed />
    <h1>Template de Contenido</h1>
    <b-row cols="12">
        <b-col cols="12" class="col-lg-4">
          <LmTextInput
            :value="`${form.createdBy.user.firstname} ${form.createdBy.user.lastname}`"
            label="Creado por"
            type="text"
            :disabled="true"
            />
        </b-col>
        <b-col cols="12" class="col-lg-4">
          <LmTextInput
            :value="form.createdBy.user.area.name"
            label="Área"
            type="text"
            :disabled="true"
            />
        </b-col>
        <b-col cols="12" class="col-lg-4">
          <LmTextInput
            :value="form.createdBy.user.subarea.name"
            label="Subárea"
            type="text"
            :disabled="true"
            />
        </b-col>
        <b-col cols="12" class="col-lg-6">
          <LmTextInput
            v-model=form.name
            :value="form.name"
            label="Nombre"
            type="text"
            :disabled="false"
            />
        </b-col>
    </b-row>
    <hr>

    <!-- Action Buttons -->
    <div class="row mt-3">
      <LmButton
        :value="$t('cancel')"
        class="col-auto"
        type="button"
        buttonClass="btn-secondary"
        @click="onCancel()"
      />
      <LmButton
        :value="$t('save')"
        class="col-auto"
        type="button"
        buttonClass="btn-primary"
        @click="onSubmit()"
      />
      <LmButton
        value="Eliminar"
        class="col-auto"
        type="button"
        action="delete"
        buttonClass="btn-danger"
        @click="onDelete()"
      />
    </div>
  </main>
</template>

<script>
// Components
import LmButton from '@/components/form/elements/LmButton'
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'

// Utils
import commonsApi from '@/api/commons'
import lmToasts from '@/mixins/lmToasts.js'
import {
  required
} from 'vuelidate/lib/validators'

export default {
  mixins: [lmToasts],
  props: {
    pathToRedirectOnCancel: {
      type: String,
      default: ''
    }
  },
  components: {
    LmButton,
    LmTextInput,
    LmTreeSelect
  },
  data () {
    return {
      form: {
        name: '',
        createdBy: {
          user: {
            firstname: '',
            lastname: '',
            area: {
              name: ''
            },
            subarea: {
              name: ''
            }
          }
        }
      },
      isLoading: false
    }
  },
  validations: {
    form: {
      name: {
        required
      }
    }
  },
  methods: {
    async onSubmit () {
      try {
        this.isLoading = true
        // Validaciones
        await this.validateForm(this.$v)

        const dataToSendToServer = {
          name: this.form.name,
          id: this.$route?.params?.id
        }

        // Envío la actualización de datos
        await commonsApi.axiosPutWrapper(`/contenttemplate/${this.$route?.params?.id}`, dataToSendToServer)
        this.lmToastSuccessMessage(`Se editó el template correctamente.`, 'Se guardó exitosamente')

        setTimeout(() => {
          this.$router.push(this.pathToRedirectOnCancel)
        }, 650)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async onDelete () {
      try {
        this.isLoading = true
        await commonsApi.axiosDeleteWrapper(`/contenttemplate/delete/${this.$route?.params?.id}`)
        this.lmToastSuccessMessage(`Se eliminó el template correctamente.`, 'Se eliminó exitosamente')
        setTimeout(() => {
          this.$router.push(this.pathToRedirectOnCancel)
        }, 650)
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    onCancel () {
      this.$router.push(this.pathToRedirectOnCancel)
    },
    validateForm (validation) {
      validation.$touch()
      if (validation.$error) {
        this.lmToastDangerMessage(this.$t('form_with_errors'), 'Error')
        throw new Error('validation error')
      } else {
        if (validation.$pending || validation.$error) {
          throw new Error('validation error')
        }
      }
    }
  },
  async created () {
    try {
      // Obtengo la información del ContentTemplate
      const contentTemplate = await commonsApi.axiosGetWrapper(`/contenttemplate/${this.$route?.params?.id}`)
      this.form = contentTemplate.data
    } catch (error) {
      console.log(error)
    }
  }
}
</script>
